<template>
	<!--

	brand new question form 

	-->
	<b-form>
		<fieldset>
			<!-- question title -->
			<b-form-row class>
				<b-col cols="12" sm="12" md="12" offset-lg="1" lg="8" offset-xl="1" xl="6">
					<b-form-group description="Title">
						<label class="sr-only" for="title">Title</label>
						<b-form-input id="title" name="title" v-model.trim="form.title" type="text" size="sm"></b-form-input>
					</b-form-group>
				</b-col>
			</b-form-row>

			<!-- question description  -->
			<b-form-row>
				<b-col cols="12" sm="12" md="12" offset-lg="1" lg="8" offset-xl="1" xl="6">
					<b-form-group description="Description">
						<label class="sr-only" for="description">Description</label>
						<b-form-textarea
							id="description"
							name="description"
							v-model="form.description"
							type="text"
							size="sm"
							rows="2"
							max-rows="2"
						></b-form-textarea>
					</b-form-group>
				</b-col>
			</b-form-row>

			<!-- answer negative  -->
			<b-form-row>
				<b-col cols="12" sm="6" md="6" offset-lg="1" lg="4" offset-xl="1" xl="3">
					<b-form-group description="Negative">
						<transition name="fade" mode="out-in">
							<!-- brand new negative answer -->
							<b-input-group v-if="selected.negative=='CREATE_NEW'">
								<b-form-input
									id="negativeAnswer"
									v-model.trim="form.answers.negative.title"
									type="text"
									name="negativeAnswer"
									size="sm"
								/>
								<b-button
									size="sm"
									key="add"
									slot="append"
									variant="info"
									:disabled="form.answers.negative.title == ''||form.answers.negative.title == null||$wait.is('saving answer')"
									@click="createNewAnswer('negative')"
								>
									<font-awesome-icon icon="plus" title="create answer" fixed-width />&nbsp;add
								</b-button>
								<b-button
									@click="selected.negative=null"
									size="sm"
									key="back"
									slot="append"
									variant="warning"
								>
									<font-awesome-icon
										icon="undo"
										title="go back to select one of existing answers instead"
										fixed-width
									/>
								</b-button>
							</b-input-group>

							<!-- existing negative answer -->
							<b-form-select
								class="text-capitalize"
								v-else
								:state="false"
								v-model="selected.negative"
								:options="answersByFeels['0']"
								@change="selectChanged('negative')"
								text-field="title"
								value-field="id"
								size="sm"
							>
								<template slot="first">
									<option value="CREATE_NEW">-- CREATE NEW --</option>
								</template>
							</b-form-select>
						</transition>
					</b-form-group>
				</b-col>

				<!-- answer positive  -->
				<b-col cols="12" sm="6" md="6" lg="4" xl="3">
					<b-form-group description="Positive">
						<transition name="fade" mode="out-in">
							<!-- brand new positve answer -->
							<b-input-group v-if="selected.positive=='CREATE_NEW'">
								<b-form-input
									id="positiveAnswer"
									v-model.trim="form.answers.positive.title"
									type="text"
									name="positiveAnswer"
									size="sm"
								/>
								<b-button
									size="sm"
									key="add"
									slot="append"
									variant="info"
									:disabled="form.answers.positive.title == ''||form.answers.positive.title == null||$wait.is('saving answer')"
									@click="createNewAnswer('positive')"
								>
									<font-awesome-icon icon="plus" title="create answer" fixed-width />&nbsp;add
								</b-button>
								<b-button
									@click="selected.positive=null"
									size="sm"
									key="back"
									slot="append"
									variant="warning"
								>
									<font-awesome-icon
										icon="undo"
										title="go back to select one of existing answers instead"
										fixed-width
									/>
								</b-button>
							</b-input-group>

							<!-- existing negative answer -->
							<b-form-select
								v-else
								class="text-capitalize"
								key="selectExisting"
								:state="true"
								v-model="selected.positive"
								:options="answersByFeels['1']"
								@change="selectChanged('positive')"
								text-field="title"
								value-field="id"
								size="sm"
							>
								<template slot="first">
									<option value="CREATE_NEW">-- CREATE NEW --</option>
								</template>
							</b-form-select>
						</transition>
					</b-form-group>
				</b-col>
			</b-form-row>
		</fieldset>
	</b-form>
</template>

<script>
	import { mapState, mapActions } from "vuex";
	import { groupBy } from "lodash";

	export default {
		name: "CreateNewQuestion_component",

		// props
		props: {
			language: Object,
			default: function() {
				return {
					id: null,
					name: null,
					shortName: null
				};
			}
		},

		// data
		data: function() {
			return {
				form: {
					title: null,
					description: null,
					answers: {
						positive: {
							title: null,
							feels: 1,
							language_id: this.language.id
						},
						negative: {
							title: null,
							feels: 0,
							language_id: this.language.id
						}
					}
				},
				selected: {
					positive: null,
					negative: null
				},
				answersByFeels: {
					1: [],
					0: []
				}
			};
		},

		// computed
		computed: {
			// get answers
			...mapState("answer", { answers: "items" }),
			// group answers by feels, positve || negative
			groupAnswersByFeels() {
				return groupBy(this.answers, "feels");
			}
		},

		// methods
		methods: {
			...mapActions("answer", ["CREATE_ANSWER", "ADD_ITEM"]),

			// save new created answer to db
			createNewAnswer(feel) {
				this.$wait.start("saving answer");
				this.CREATE_ANSWER({
					data: this.form.answers[feel]
				}).then(
					answer => {
						this.$wait.end("saving answer");
						this.form.answers[feel] = answer;
						this.selected[feel] = answer.id;
						this.ADD_ITEM(answer);
						this.answersByFeels = this.groupAnswersByFeels;
					},
					error => {
						this.$wait.end("saving answer");
						this.showToast(
							"danger",
							status + " " + error.statusText,
							error.data.message
						);
					}
				);
			},

			// asign selected answer to form
			selectChanged(feel) {
				// find answer by id and add it as answer to question
				this.form.answers[feel] = this.answers.find(
					({ id }) => id === this.selected[feel]
				);
			}
		},

		// mounted hook
		mounted() {
			// // show loader
			this.$wait.start("lodaing answers");

			// fetch accept-protocol
			this.$store
				.dispatch("answer/GET_ANSWER_LIST", {
					language_id: this.language.id
				})
				.then(
					() => {
						this.$wait.end("loading answers");
						this.answersByFeels = this.groupAnswersByFeels;
					},
					error => {
						this.$wait.end("loading answers");
						this.showToast("danger", error.statusText, error.data.message);
					}
				);
		}
	};
</script>

<style scoped>
</style>
